import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2222cfe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "captcha-wrapper" }
const _hoisted_2 = { class: "captcha-row" }
const _hoisted_3 = ["width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", {
        ref: "canvasRef",
        width: _ctx.width,
        height: _ctx.height,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args))),
        title: "Clic para refrescar"
      }, null, 8, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
      }, "↻")
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userInput) = $event)),
      type: "text",
      placeholder: "Escribe el texto de la imagen",
      autocomplete: "off",
      onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.verify && _ctx.verify(...args)), ["enter"]))
    }, null, 544), [
      [_vModelText, _ctx.userInput]
    ]),
    (_ctx.status)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(['status', _ctx.status])
        }, _toDisplayString(_ctx.status === 'success' ? 'Verificación exitosa ✓' : 'Código incorrecto, intenta de nuevo'), 3))
      : _createCommentVNode("", true)
  ]))
}